export default "__VITE_ASSET__BMhHh73I__"